import { z } from 'zod';
import { isRealDate, paginationQuerySchema, uuidSchema } from './common.js';
const text = (max) => z
    .string()
    .trim()
    .max(max)
    .refine((v) => !v.includes('\u0000'), 'Invalid character');
const isoDate = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Use YYYY-MM-DD')
    .refine(isRealDate, 'Invalid calendar date');
const atLeastOne = (v) => Object.keys(v).length > 0;
export const HOMEWORK_STATUSES = ['published', 'closed'];
/** What the teacher has recorded for one student. A student without a record is "pending". */
export const SUBMISSION_STATUSES = ['pending', 'submitted', 'late', 'excused', 'missing'];
export const createHomeworkSchema = z
    .object({
    academicYearId: uuidSchema.optional(),
    sectionId: uuidSchema,
    subjectId: uuidSchema,
    title: text(200).min(1),
    instructions: text(4000).default(''),
    assignedOn: isoDate.optional(),
    dueDate: isoDate,
})
    .refine((v) => !v.assignedOn || v.dueDate >= v.assignedOn, {
    message: 'The due date cannot be before the day it is set',
    path: ['dueDate'],
});
export const updateHomeworkSchema = z
    .object({
    title: text(200).min(1),
    instructions: text(4000),
    dueDate: isoDate,
    status: z.enum(HOMEWORK_STATUSES),
})
    .partial()
    .refine(atLeastOne, 'At least one field is required');
const flag = z.enum(['true', 'false']).transform((v) => v === 'true');
export const listHomeworkQuerySchema = paginationQuerySchema.extend({
    sectionId: uuidSchema.optional(),
    classId: uuidSchema.optional(),
    subjectId: uuidSchema.optional(),
    status: z.enum(HOMEWORK_STATUSES).optional(),
    /** Only work whose due date is today or later. */
    upcoming: flag.optional(),
});
export const markSubmissionsSchema = z
    .object({
    records: z
        .array(z.object({
        studentId: uuidSchema,
        status: z.enum(SUBMISSION_STATUSES),
        feedback: text(1000)
            .transform((v) => (v === '' ? null : v))
            .nullable()
            .optional(),
    }))
        .min(1)
        .max(300),
})
    .refine((v) => new Set(v.records.map((r) => r.studentId)).size === v.records.length, {
    message: 'A student can appear only once',
    path: ['records'],
});
//# sourceMappingURL=homework.js.map